import { sendEvent } from "../metrics/events";
import { VIRTUAL_PAGES } from "../metrics/config";

function clickEvent(event) {
  const el = event.target.closest("[data-metrics-id]");
  if (!el) return;
  const id = el.dataset.metricsId;
  let events = el.dataset.metricsEvents;
  events && (events = events.split(","));
  if (!events.includes("click")) return;
  sendEvent("click", id);
}

function createMetricsPlugin() {
  document.addEventListener("click", clickEvent);

  Alpine.magic("sendEvent", () => {
    return (event, id) => sendEvent(event, id);
  });

  Alpine.directive("metrics", (el, { value, modifiers, expression }, { Alpine, effect, cleanup, evaluate }) => {
    let events;
    events = Object.keys(VIRTUAL_PAGES).filter((k) => modifiers.includes(k));

    if (events.includes("click")) {
      el.dataset.metricsId = expression;
      el.dataset.metricsEvents = events;
      if (modifiers[modifiers.indexOf("click") + 1] === "self") {
        let clickHandler = function (event) {
          clickEvent(event);
          event.stopPropagation();
        };
        el.addEventListener("click", clickHandler);
        cleanup(() => {
          el.removeEventListener("click", clickHandler);
        });
      }
    }

    if (events.includes("scroll")) {
      el.setAttribute("x-intersect.threshold.05.once", `$sendEvent('scroll', '${expression}')`);
    }
  });
}

export { createMetricsPlugin };
